export function trackUmamiEvent(eventName, analytics) {
  if (typeof analytics?.track !== 'function') {
    return false;
  }

  try {
    analytics.track(eventName);
    return true;
  } catch {
    return false;
  }
}

export function consumeLeadCreatedMarker(
  browserWindow,
  replaceState = browserWindow.history.replaceState.bind(browserWindow.history),
) {
  const url = new URL(browserWindow.location.href);

  if (url.searchParams.get('lead_created') !== '1') return false;

  if (!trackUmamiEvent('lead-created', browserWindow.umami)) {
    return false;
  }

  url.searchParams.delete('lead_created');
  replaceState(
    browserWindow.history.state,
    '',
    `${url.pathname}${url.search}${url.hash}`,
  );
  return true;
}

export function trackPhoneClick(event, analytics) {
  if (!event.target?.closest?.('a[href^="tel:"]')) return false;

  return trackUmamiEvent('phone-cta-click', analytics);
}

export function initUmamiEvents(
  browserWindow = window,
  browserDocument = document,
) {
  const replaceState = browserWindow.history.replaceState.bind(
    browserWindow.history,
  );

  browserWindow.onclickObserver.subscribe(event => {
    trackPhoneClick(event, browserWindow.umami);
  });

  browserDocument.addEventListener(
    'DOMContentLoaded',
    () => consumeLeadCreatedMarker(browserWindow, replaceState),
    { once: true },
  );
}
